export const sortByCount = (a, b) => a.misspelledCount - b.misspelledCount;
